import { useState } from 'react'
import { GetProviderProfileInfo, GetProviderProfile } from '@endpoints/ProviderProfile'
import { LoadListDefault, useGet } from '../../../api/hooks'
import { useTranslation } from 'react-i18next'
import ProfileData from './ProfileData'
import EditProfile from './EditProfile'
import { Icon } from '@iconify/react'
import './style.css'
import { Block, CRRender } from '@/components/crRender'
import ActionBtn from '@/components/ActionBtn'

const ProviderProfile = () => {

  const { t } = useTranslation()
  const [isEditMode, setIsEditMode] = useState(false)

  const { result: providerInfo, isPending, fetchData: fetchInfo } = useGet({ ...LoadListDefault, params: [], allowFetch: true, depArr: [], endPoint: GetProviderProfileInfo })
  const { result: ProviderProfile, isPending: isProfilePending, fetchData: fetchProfile } = useGet({ ...LoadListDefault, params: [], allowFetch: true, depArr: [], endPoint: GetProviderProfile })


  const handleCancelEdit = () => {
    fetchProfile()
    setIsEditMode(false)
  }

  const handleEditProfile = () => {
    setIsEditMode(true)
    fetchInfo()
  }


  return (
    <>
      {/* View Mode Header with Edit Button */}
      <Block isRender={!isEditMode} className="provider-profile-header p-10">
        <h4 className="provider-profile-title">{t("hospital-portfolio")}</h4>
        <ActionBtn onApply={() => handleEditProfile()} className="btn-primary m-0" title={"edit-profile"} icon="mdi:pencil" />
      </Block>

      <CRRender isRender={!!isEditMode}>
        <EditProfile cancelAction={
          <CRRender isRender={!!isEditMode}>
            <div className="pointer cancel-btn" onClick={() => handleCancelEdit()}>{t("cancel")}</div>
          </CRRender>
        }
          providerInfo={{ ...providerInfo, paymentTerms: ProviderProfile?.paymentTerms }}
          isPending={isPending}
        />
      </CRRender>
      <CRRender isRender={!isEditMode}>
        <ProfileData requestDetails={ProviderProfile} isPending={isProfilePending} />
      </CRRender>

    </>
  )
}

export default ProviderProfile
